export const SIDEBAR = {
  width: 248,
  collapsedWidth: 87,
  mobileHeight: 75,
  mobileTab: 40,
  iconWidth: 40,
  itemTextMargin: 8,
  basePadding: 8,
};

export const TRANSITION_SPEED = 0.3;
